import * as React from 'react';

/**
 * @return {React.ReactElement}
 * @constructor
 */
export default function Replace(): React.ReactElement {
  return (
    <svg width="15" height="15" viewBox="0 0 15 15" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M6.00315 1.71528C7.18668 1.71528 8.25874 2.19557 9.03487 2.9717L6.86081 5.1458H12.0066V0L10.2485 1.75813C9.16356 0.673255 7.66267 0 6.00315 0C2.98 0 0.484284 2.23842 0.0683594 5.1458H1.80076C2.19956 3.19039 3.92771 1.71528 6.00315 1.71528Z" />
      <path d="M10.8405 9.54976C11.4108 8.77359 11.7967 7.85595 11.9382 6.86108H10.2058C9.80704 8.81649 8.0789 10.2916 6.00342 10.2916C4.81988 10.2916 3.74783 9.81131 2.9717 9.03518L5.1458 6.86108H0V12.0069L1.75813 10.2487C2.84305 11.3337 4.3439 12.0069 6.00342 12.0069C7.33276 12.0069 8.55915 11.5695 9.55402 10.8362L13.7221 15L15 13.7221L10.8405 9.54976Z" />
    </svg>
  );
}
